<template>
  <div class="text-area">
    <div
      class="row mb-2 ms-1 ps-3 pe-4"
      :style="`background: linear-gradient(
                        90deg,
                        rgba(180, 96, 220, 0.1) 0%,
                        rgba(180, 96, 220, 0.1) ${percent(
                          modelValue?.total?.success?.orders / totalCount
                        )}%,
                        rgba(180, 96, 220, 0) ${percent(
                          modelValue?.total?.success?.orders / totalCount
                        )}%,
                        rgba(180, 96, 220, 0) 100%
                      );`"
    >
      <div class="col-8 pt-1 bold-14 text-gradient">
        {{ $t("home.successful") }}
      </div>
      <div class="col bold-19 text-gradient text-end">
        {{ percent(modelValue?.total?.success?.orders / totalCount) }}%
      </div>
    </div>
    <div
      class="row mb-2 ms-1 ps-3 pe-4"
      :style="`background: linear-gradient(
                        90deg,
                        rgba(180, 96, 220, 0.1) 0%,
                        rgba(180, 96, 220, 0.1) ${percent(
                          modelValue?.total?.failed?.count / totalCount
                        )}%,
                        rgba(180, 96, 220, 0) ${percent(
                          modelValue?.total?.failed?.count / totalCount
                        )}%,
                        rgba(180, 96, 220, 0) 100%
                      );`"
    >
      <div class="col-8 pt-1 bold-14 text-gradient">
        {{ $t("home.failed") }}
      </div>
      <div class="col bold-19 text-gradient text-end">
        {{ percent(modelValue?.total?.failed?.count / totalCount) }}%
      </div>
    </div>
    <div
      class="row mb-2 ms-1 ps-3 pe-4"
      :style="`background: linear-gradient(
                        90deg,
                        rgba(180, 96, 220, 0.1) 0%,
                        rgba(180, 96, 220, 0.1) ${percent(
                          modelValue?.total?.not_finished?.count / totalCount
                        )}%,
                        rgba(180, 96, 220, 0) ${percent(
                          modelValue?.total?.not_finished?.count / totalCount
                        )}%,
                        rgba(180, 96, 220, 0) 100%
                      );`"
    >
      <div class="col-8 pt-1 bold-14 text-gradient">
        {{ $t("home.notFinished") }}
      </div>
      <div class="col bold-19 text-gradient text-end">
        {{
          percent(
            modelValue?.total?.not_finished?.count / modelValue?.totalCount
          )
        }}%
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SuccessRate",
  props: {
    key: Number,
    modelValue: Object,
  },
  data() {},
  computed: {
    totalCount() {
      return (
        this.modelValue?.total?.success?.orders +
        this.modelValue?.total?.failed?.count +
        this.modelValue?.total?.not_finished?.count
      );
    },
  },
  methods: {
    percent(val) {
      return Math.round(val * 10000) / 100;
    },
  },
};
</script>
